<template>
  <div>
    <b-button @click.prevent="$emit('btnClicked')" :class="btnClass" :size="size" :variant="variant">{{ text }}</b-button>
  </div>
</template>

<script>
export default {
  props: {
    btnClass: String,
    variant: String,
    text: String,
    size: String
  }
}
</script>

<style scoped>
/* Register, login and confirm button classes */
.register-btn, .confirm-btn, .login-btn {
  width: 100%;
}
.register-btn button, .confirm-btn button, .login-btn button {
  width: 100%;
  color: #fff !important;
}
.register-btn button {
  background-color: #ffa409;
}
.register-btn button:hover {
  background-color: #af6f00;
}
/* Save button classes */
.save-btn {
  
}
@media only screen and (min-width: 992px) {
  .save-btn {
    
  }
}
/* Logout button classes */
.logout-btn {
  position: fixed;
  top: 96px;
  left: 20px;
  z-index: 1;
}
@media only screen and (min-width: 992px) {
  .logout-btn {
    top: 176px;
  }
}
/* Progress button classes */
</style>
